var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonUsers.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import HeaderContext from '../../HeaderContext';
export var COPY = defineMessages({
  ADD_USERS: {
    id: 'ButtonUsers.addUsers',
    defaultMessage: 'Add users',
    description: '[Type: Label][Vis.: high] - This is the add users addon button on the header.'
  }
});
var ButtonUsers = function ButtonUsers() {
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  return /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "upgrade",
    href: createURL('/team/add/', {
      ut_source: 'header',
      ut_source3: 'webplat'
    }),
    "data-sm-metrics": generateMetricsAttribute({
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked cta',
        ctaName: 'add users'
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.ADD_USERS,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }));
};
export default ButtonUsers;
//# sourceMappingURL=ButtonUsers.js.map